import {Group, Stack, Text, Title} from '@mantine/core'
import type {ReactNode} from 'react'

type PageHeaderProps = {
    title: string
    description?: string
    actions?: ReactNode
}

export function PageHeader({title, description, actions}: PageHeaderProps) {
    return (
        <Group justify="space-between" align="flex-start" wrap="nowrap" gap="md" mb={24}>
            <Stack gap={0} style={{flex: 1, minWidth: 0}}>
                <Title order={3} fw={700} c="brand.9">
                    {title}
                </Title>
                {description && (
                    <Text c="dimmed" size="sm" mt={4}>
                        {description}
                    </Text>
                )}
            </Stack>
            {actions ? <div style={{flexShrink: 0}}>{actions}</div> : null}
        </Group>
    )
}
